import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { AuthService } from './auth.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  public handleError(error: unknown): void {
    // eslint-disable-next-line no-console
    console.error(error);

    if (this.isIgnorableError(error)) {
      return;
    }

    const dbUser = AuthService.currentDbUser;
    const firebaseUser = AuthService.currentFirebaseUser;
    const capturedError = this.getCapturedError(error);
    const currentGroup = dbUser?.userGroups?.find((g) => g.id === dbUser.userGroupId);

    Sentry.withScope((scope) => {
      if (dbUser) {
        scope.setUser({
          email: firebaseUser?.email ?? undefined,
          id: dbUser.id,
          userGroupId: dbUser.userGroupId,
          userGroupName: currentGroup?.name,
          username: dbUser.name ?? undefined,
        });
        scope.setExtra('firebaseUid', firebaseUser?.uid ?? undefined);
        scope.setExtra('campaignVersion', dbUser.campaignVersion);
        scope.setExtra('effectivePermissions', dbUser.effectivePermissions);
      }

      Sentry.captureException(capturedError);
    });
  }

  private isIgnorableError(error: unknown): boolean {
    return this.isIgnorableNg0100(error) || this.isIgnorableLocalUrl();
  }

  private isIgnorableNg0100(error: unknown): boolean {
    const message = this.getErrorMessage(error);

    if (message.includes('NG0100') || message.includes('ExpressionChangedAfterItHasBeenCheckedError')) {
      return true;
    }

    return false;
  }

  private isIgnorableLocalUrl(): boolean {
    return window.location.hostname.includes('localhost');
  }

  private getErrorMessage(error: unknown): string {
    return error instanceof Error ? error.message : typeof error === 'string' ? error : JSON.stringify(error);
  }

  private getCapturedError(error: unknown): Error {
    return error instanceof Error ? error : new Error(error instanceof Object ? JSON.stringify(error) : String(error));
  }
}
